import { render } from "./ApproveConfirmModal.vue?vue&type=template&id=61a254df"
import script from "./ApproveConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ApproveConfirmModal.vue?vue&type=script&lang=ts"
script.render = render

export default script